import { Suspense } from "react"; // Import other components

import hyper from "@macrostrat/hyper";
import Searchbar from "../components/searchbar";
import { ButtonGroup, Button, Spinner } from "@blueprintjs/core";
import { useSelector, useDispatch } from "react-redux";
import loadable from "@loadable/component";
import { useSearchState, MapBackend, useAppState, useAppActions } from "../app-state";
import styles from "./main.module.styl";
import classNames from "classnames";
import { useRef, useEffect } from "react";
import { useTransition } from "transition-hook";
import { useContextPanelOpen, useContextClass } from "../app-state";
import { MapboxMapProvider, ZoomControl } from "@macrostrat/mapbox-react";
import { MapBottomControls, MapStyledContainer } from "./map-view";
import { Routes, Route, useParams } from "react-router-dom";
import { MenuPage } from "./menu";
var ElevationChart = loadable(function () {
  return import("../components/elevation-chart");
});
var InfoDrawer = loadable(function () {
  return import("../components/info-drawer");
});
var MapContainer = loadable(function () {
  return import("./map-view");
});
var Menu = loadable(function () {
  return import("./menu");
});
var h = hyper.styled(styles); //const CesiumViewMod = loadable(() => import("./cesium-view"));

var CesiumViewMod = function CesiumViewMod() {
  return h("div", "Globe is currently disabled");
};

export function CesiumView(props) {
  return h(Suspense, {
    fallback: h(Spinner)
  }, h(CesiumViewMod, props));
}

function MapContainerBase(props) {
  return h(Suspense, {
    fallback: h(Spinner)
  }, h(MapContainer, props));
}

var MapView = function MapView(props) {
  var _props$backend = props.backend,
      backend = _props$backend === void 0 ? MapBackend.MAPBOX3 : _props$backend;

  switch (backend) {
    case MapBackend.CESIUM:
      return h(CesiumView);

    default:
      //const use3D = backend == MapBackend.MAPBOX3;
      return h(MapContainerBase);
  }
};

var MapTypeSelector = function MapTypeSelector() {
  var backend = useSelector(function (d) {
    return d.update.mapBackend;
  });
  var dispatch = useDispatch();

  var setBackend = function setBackend(backend) {
    dispatch({
      type: "set-map-backend",
      backend: backend
    });
  };

  return h(ButtonGroup, {
    className: "map-type-selector"
  }, [h(Button, {
    active: backend == MapBackend.MAPBOX,
    onClick: function onClick() {
      setBackend(MapBackend.MAPBOX);
    }
  }, "2D"), h(Button, {
    active: backend == MapBackend.MAPBOX3,
    onClick: function onClick() {
      setBackend(MapBackend.MAPBOX3);
    }
  }, "3D"), h(Button, {
    active: backend == MapBackend.CESIUM,
    onClick: function onClick() {
      setBackend(MapBackend.CESIUM);
    }
  }, "Globe (alpha)")]);
};

var MapPage = function MapPage(_ref) {
  var _ref$backend = _ref.backend,
      backend = _ref$backend === void 0 ? MapBackend.MAPBOX3 : _ref$backend,
      _ref$menuPage = _ref.menuPage,
      menuPage = _ref$menuPage === void 0 ? null : _ref$menuPage;

  var _useSearchState = useSearchState(),
      inputFocus = _useSearchState.inputFocus;

  var runAction = useAppActions();
  var infoDrawerOpen = useAppState(function (s) {
    return s.core.infoDrawerOpen;
  });
  var navMenuPage = useAppState(function (s) {
    return s.menu.activePage;
  });
  var ref = useRef(null);
  var contextPanelOpen = useContextPanelOpen();
  var contextPanelTrans = useTransition(contextPanelOpen || inputFocus, 800);
  var detailPanelTrans = useTransition(infoDrawerOpen, 800);
  /* We apply a custom style to the panel container when we are interacting
    with the search bar, so that we can block map interactions until search
    bar focus is lost.
    We also apply a custom style when the infodrawer is open so we can hide
    the search bar on mobile platforms
  */

  var className = classNames({
    searching: inputFocus,
    "detail-panel-open": infoDrawerOpen
  }, "context-panel-".concat(contextPanelTrans.stage), "detail-panel-".concat(detailPanelTrans.stage));
  var contextClass = useContextClass();

  var onMouseDown = function onMouseDown(event) {
    var _ref$current;

    if (!(inputFocus || contextPanelOpen)) return;
    if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target)) return;
    runAction({
      type: "context-outside-click"
    });
    event.stopPropagation();
  };

  var loaded = useSelector(function (state) {
    return state.core.initialLoadComplete;
  });
  useEffect(function () {
    runAction({
      type: "get-initial-map-state"
    });
  }, []);
  if (!loaded) return h(Spinner);
  return h(MapboxMapProvider, [h(MapStyledContainer, {
    className: "map-page"
  }, [h("div.main-ui", {
    className: className,
    onMouseDown: onMouseDown
  }, [h("div.context-stack", {
    className: contextClass,
    ref: ref
  }, [h(Searchbar, {
    className: "searchbar"
  }), h["if"](contextPanelTrans.shouldMount)(Menu, {
    className: "context-panel",
    menuPage: menuPage !== null && menuPage !== void 0 ? menuPage : navMenuPage
  })]), h(MapView, {
    backend: backend
  }), h("div.detail-stack.infodrawer-container", [h(Routes, [h(Route, {
    path: "/loc/:lng/:lat",
    element: h(InfoDrawerRoute)
  }) // h.if(detailPanelTrans.shouldMount)(InfoDrawer, {
  //   className: "detail-panel",
  // }),
  ]), h(ZoomControl, {
    className: "zoom-control"
  }), h("div.spacer"), h(MapBottomControls)])]), h("div.bottom", null, h(ElevationChart, null))])]);
};

function MapPageRoutes() {
  return h(Routes, [h(Object.values(MenuPage).map(function (page) {
    return h(Route, {
      path: page,
      element: h(MapPage, {
        menuPage: page
      })
    });
  })), h(Route, {
    path: "*",
    element: h(MapPage)
  })]);
}

function InfoDrawerRoute() {
  var _useAppState;

  var _useParams = useParams(),
      lat = _useParams.lat,
      lng = _useParams.lng;

  var infoDrawerOpen = useAppState(function (s) {
    return s.core.infoDrawerOpen;
  });
  var z = Math.round((_useAppState = useAppState(function (s) {
    var _s$core$mapPosition$t;

    return (_s$core$mapPosition$t = s.core.mapPosition.target) === null || _s$core$mapPosition$t === void 0 ? void 0 : _s$core$mapPosition$t.zoom;
  })) !== null && _useAppState !== void 0 ? _useAppState : 7);
  var detailPanelTrans = useTransition(infoDrawerOpen, 800);
  var runAction = useAppActions();
  useEffect(function () {
    if (lat && lng) {
      runAction({
        type: "run-map-query",
        lat: Number(lat),
        lng: Number(lng),
        z: z
      });
    }
  }, [lat, lng]);
  return h["if"](detailPanelTrans.shouldMount)(InfoDrawer, {
    className: "detail-panel"
  });
} //const _MapPage = compose(HotkeysProvider, MapPage);


export { MapBackend };
export default MapPageRoutes;